<app-rc-dialog-wrapper (closePopin)="dismiss()">
  <div class="purchase-products-popin-wrapper">
    <h2 class="details-popin_title">{{ 'new-DAC-flow_purchase_button' | translateKey }}</h2>

    @if (poLetterQrCode$ | async; as poLetterQrCode) {
      <app-qr-code-display [qrCodeLink]="poLetterQrCode" [instructions]="'QRcode-popin_purchase_IVO' | translateKey"></app-qr-code-display>
    }
    <rc-button data-qa="vs-purchase-products-popin-button-cancel" variant="primary" size="medium" (click)="dismiss()">
      {{ 'action_cancel' | translateKey }}
    </rc-button>
  </div>
</app-rc-dialog-wrapper>
